var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptybooking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_559_34379)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.25,
    y: 8,
    width: 56,
    height: 56,
    rx: 28,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2477 29.3299V50.3524",
    stroke: "url(#paint0_linear_559_34379)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2441 30.1642H31.2462",
    stroke: "url(#paint1_linear_559_34379)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2441 36H31.2462",
    stroke: "url(#paint2_linear_559_34379)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2441 41.8358H31.2462",
    stroke: "url(#paint3_linear_559_34379)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.25 30.1642H46.2521",
    stroke: "url(#paint4_linear_559_34379)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.25 36H46.2521",
    stroke: "url(#paint5_linear_559_34379)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.25 41.8358H46.2521",
    stroke: "url(#paint6_linear_559_34379)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2484 51.0061C35.226 48.9598 33.1336 47.6684 30.8462 47.6717H23.7422C23.0792 47.6717 22.4433 47.4083 21.9744 46.9394C21.5056 46.4706 21.2422 45.8347 21.2422 45.1716V25.161C21.2422 24.4979 21.5056 23.862 21.9744 23.3932C22.4433 22.9243 23.0792 22.6609 23.7422 22.6609H29.5797C31.3483 22.6609 33.0446 23.3635 34.2952 24.6142C35.5458 25.8648 36.2484 27.561 36.2484 29.3297C36.2484 25.6466 39.2342 22.6609 42.9172 22.6609H48.7546C49.4177 22.6609 50.0536 22.9243 50.5224 23.3932C50.9913 23.862 51.2547 24.4979 51.2547 25.161V45.1716C51.2547 46.55 50.139 47.6683 48.7607 47.6717H41.6507C39.3632 47.6684 37.2709 48.9598 36.2484 51.0061Z",
    stroke: "url(#paint7_linear_559_34379)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_559_34379",
    x: 0.249999,
    y: -9.53674e-7,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_559_34379"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.733333 0 0 0 0 0.764706 0 0 0 0 0.807843 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_559_34379",
    result: "effect2_dropShadow_559_34379"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_559_34379",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_559_34379",
    x1: 36.2477,
    y1: 29.3299,
    x2: 36.2477,
    y2: 50.3524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B349A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C37C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_559_34379",
    x1: 28.7452,
    y1: 29.3306,
    x2: 28.7452,
    y2: 30.9979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B349A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C37C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_559_34379",
    x1: 28.7452,
    y1: 35.1663,
    x2: 28.7452,
    y2: 36.8337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B349A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C37C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_559_34379",
    x1: 28.7452,
    y1: 41.0021,
    x2: 28.7452,
    y2: 42.6695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B349A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C37C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_559_34379",
    x1: 43.751,
    y1: 29.3306,
    x2: 43.751,
    y2: 30.9979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B349A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C37C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_559_34379",
    x1: 43.751,
    y1: 35.1663,
    x2: 43.751,
    y2: 36.8337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B349A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C37C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_559_34379",
    x1: 43.751,
    y1: 41.0021,
    x2: 43.751,
    y2: 42.6695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B349A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C37C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_559_34379",
    x1: 36.2484,
    y1: 22.6609,
    x2: 36.2484,
    y2: 51.0061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B349A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C37C3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptybooking);
export default __webpack_public_path__ + "static/media/emptybooking.5d488cad6c2ea5a71c8903b83b73e478.svg";
export { ForwardRef as ReactComponent };